import '@archetype-themes/scripts/config';

/*
  CT: Section Rendering API.
  Elke cart-mutatie vraagt sections/ct-cart-ajax.liquid mee, zodat het
  antwoord de verse cart-markup al bevat en er geen tweede request naar
  /cart?view=ajax nodig is. cart-form.js past die markup toe via
  applySections(); getCartProductMarkup() blijft de fallback.

  sections_url zet de URL-context (locale/market) van de render. De
  cart-routes zijn al gelokaliseerd, maar zo staat het buiten kijf.
*/
theme.cart = {
  sectionId: 'ct-cart-ajax',

  sectionParams: function() {
    return {
      sections: this.sectionId,
      sections_url: window.location.pathname
    };
  },

  getCart: function() {
    var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(response => response.json());
  },

  getCartProductMarkup: function() {
    var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

    url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(response => response.text())
    .catch(e => console.error(e));
  },

  changeItem: function(key, qty) {
    var payload = Object.assign({
      id: key,
      quantity: qty
    }, this.sectionParams());

    return this._updateCart({
      url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
      data: JSON.stringify(payload)
    })
  },

  _updateCart: function(params) {
    return fetch(params.url, {
      method: 'POST',
      body: params.data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
    .then(response => { return response.text() })
    .then(cart => { return cart; });
  },

  updateAttribute: function(key, value) {
    return this._updateCart({
      url: '/cart/update.js',
      data: JSON.stringify({
        attributes: {
          [key]: theme.cart.attributeToString(value)
        }
      })
    });
  },

  updateNote: function(note) {
    return this._updateCart({
      url: '/cart/update.js',
      data: JSON.stringify({
        note: theme.cart.attributeToString(note)
      })
    });
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return attribute.trim();
  }
}
